module.exports = __webpack_public_path__ + "static/media/CVWK9545a.d99289cb.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/kama_yunek/CVWK9545a.JPG
// module id = 153
// module chunks = 0